/**
 * RunRun 2026-08-03 — Sinónimos de búsqueda DM AR: borcego → bota.
 *
 * El 15-jul-2026 se barrió la palabra "borcego" de todo el sitio (decisión de
 * marca). El buscador quedó sin la palabra que el cliente argentino usa: hoy
 * "borcegos" da 0 productos en el dropdown predictivo y 6 en la página /search,
 * contra 54 de "botas". GA4 (searchTerm) registra ~2 búsquedas/día de "borceg*",
 * el término no-modelo más buscado después de "buzz" y los códigos 1460/1461.
 *
 * Este remapeo es invisible al cliente (no imprime la palabra en ningún lado) y
 * no toca copy, así que respeta la regla de marca. Actúa en tres puntos:
 *  1. el fetch de la búsqueda predictiva (dropdown del header),
 *  2. la página /search (redirect con la query mapeada),
 *  3. el submit de cualquier form de búsqueda.
 *
 * Reemplazo por TOKEN (no por query completa) para que las búsquedas compuestas
 * sigan funcionando: "borcegos plataforma" → "botas plataforma".
 * Mismo patrón que rr-search-synonyms.js de DM CL.
 */
(function () {
  'use strict';

  // Cubre borc / borce / borceg / borcego / borcegos / borcegui / borceguies
  // y typos de tipeo intermedio (>=4 chars) mientras se escribe en el dropdown.
  var BORCEGO_RE = /^borc(e(g[a-z]*|gui[a-z]*)?)?$/;
  var TARGET = 'botas';

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mapTerm(q) {
    var n = norm(q);
    if (!n || n.indexOf('borc') === -1) return null;
    var tokens = n.split(' ');
    var changed = false;
    var out = tokens.map(function (t) {
      // token exacto (o prefijo tipeado a medias, de 4 chars en adelante)
      if (t.length >= 4 && BORCEGO_RE.test(t)) { changed = true; return TARGET; }
      // pegado a otra palabra: "botasborcego" → "botas"
      if (t.length > 6 && t.indexOf('borceg') !== -1) { changed = true; return TARGET; }
      return t;
    });
    if (!changed) return null;
    // "botas botas plataforma" → "botas plataforma"
    var dedup = out.filter(function (t, i) { return i === 0 || t !== out[i - 1]; });
    var mapped = dedup.join(' ');
    return mapped !== n ? mapped : null;
  }

  // 1) Dropdown predictivo: interceptar el fetch a predictive_search_url.
  var predictivePath = (window.Theme && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var urlStr = typeof input === 'string' ? input : (input && input.url);
      if (urlStr && urlStr.indexOf(predictivePath) !== -1) {
        var u = new URL(urlStr, location.origin);
        var mapped = mapTerm(u.searchParams.get('q'));
        if (mapped) {
          u.searchParams.set('q', mapped);
          input = typeof input === 'string' ? u.toString() : new Request(u.toString(), input);
        }
      }
    } catch (e) { /* ante cualquier duda, no tocar el request */ }
    return origFetch.call(this, input, init);
  };

  // 2) Página de resultados: si llegó con un término mapeable, redirigir.
  //    rr_from conserva el término original para leer la demanda real en GA4.
  if (location.pathname.replace(/\/$/, '').slice(-7) === '/search') {
    var pageUrl = new URL(location.href);
    var mappedQ = mapTerm(pageUrl.searchParams.get('q'));
    if (mappedQ && !pageUrl.searchParams.get('rr_from')) {
      pageUrl.searchParams.set('rr_from', pageUrl.searchParams.get('q'));
      pageUrl.searchParams.set('q', mappedQ);
      pageUrl.searchParams.delete('page');
      location.replace(pageUrl.toString());
    }
  }

  // 3) Submit de forms de búsqueda (header/modal): remapear antes de navegar.
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.action) return;
      var action = new URL(form.action, location.origin);
      if (action.pathname.replace(/\/$/, '').slice(-7) !== '/search') return;
      var input = form.querySelector('input[name="q"]');
      var mapped = input && mapTerm(input.value);
      if (mapped) input.value = mapped;
    } catch (err) { /* noop */ }
  }, true);
})();
